import React, { useEffect } from "react";
import {
  AppTopNaviDivider,
  AppTopNavi,
  AppTopNaviItem,
  Button,
} from "@abb/abb-common-ux-react";
import avtar from "../../assets/Avatar.png";
import logo from "../../assets/Logo.png";
import { useNavigate } from "react-router-dom";
import { Auth } from "aws-amplify";

import "./navbar.css";
function Navbar() {
  const getCurrentMenu = localStorage.getItem("current-page");
  const [monochrome, setMonochrome] = React.useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = React.useState(false);
  const [activeItem, setActiveItem] = React.useState(
    getCurrentMenu ? getCurrentMenu : "Dashboard"
  );
  const navigate = useNavigate();

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 768) {
        setIsMobileMenuOpen(false);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const logout = async () => {
    localStorage.clear();
    localStorage.setItem("isLogin", "false");
    try {
      await Auth.signOut();
      console.log("User logged out");
    } catch (error) {
      console.log("Error signing out:", error);
    }
    navigate("../");
  };
  return (
    <div className={`header-container ${isMobileMenuOpen ? "mobile-menu-open" : ""}`}>
      <div className="brand">
        <div>
          <img className="avtar-icon" src={logo} alt="" />
        </div>

        <div className="brand-name">
          {/* <AppTopNaviDivider  /> */}
          <div className="project-name">
            <AppTopNaviDivider />
            <div>
              <div className="title-name">
                CogniEN<sup id="super">TM</sup>
              </div>
              {/* <div>DR Monitoring System</div> */}
            </div>
          </div>
        </div>
      </div>

      <AppTopNavi monochrome={monochrome} allowScroll={true}>
        {/* Enable this post deploy */}
        <AppTopNaviItem
          text="Ratingen"
          active={activeItem === "ratingen"}
          onClick={() => {
            setActiveItem("ratingen");
            navigate("../ratingen");
            localStorage.setItem("current-page", "ratingen");
          }}
        />


      </AppTopNavi>
      <div className="desktop-actions">
        <Button
          text="Logout"
          onClick={logout}
          shape="pill"
          type="primary-black"
        />
        <div className="profile">
          <img className="menu-avatar" src={avtar} alt="" />
        </div>
      </div>

      <div className="mobile-menu-wrapper">
        <button
          type="button"
          className="mobile-menu-button"
          aria-label="Open menu"
          aria-expanded={isMobileMenuOpen}
          onClick={() => setIsMobileMenuOpen((prev) => !prev)}
        >
          <i className="ABB_CommonUX_Icon__root">
            <i className="ABB_CommonUX_Icon__icon_abb_16 ABB_CommonUX_Icon-16-style__icon-abb_menu_16" />
          </i>
        </button>

        {isMobileMenuOpen && (
          <>
            <div
              className="mobile-menu-backdrop"
              onClick={() => setIsMobileMenuOpen(false)}
            />
            <div className="mobile-menu-panel">
              <div className="mobile-menu-profile">
                <img className="menu-avatar" src={avtar} alt="" />
              </div>
              <Button
                text="Logout"
                onClick={logout}
                shape="pill"
                type="primary-black"
              />
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default Navbar;
